import React, { useContext, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Context from '../../utils/context';
import { isPhoneCallsEnabled } from '../../helpers/feature_checker.js';
import styles from './new_settings.module.css';
import { activeKeyFromPath, BottomNav, MobileHub, pathForSection, Rail } from './new_settings/navigation';
import NewProfileEdit from './new_settings/profile_edit';
import { AccountSubpage } from './new_settings/sections';
import SettingsShell from './new_settings/settings_shell';
import useSettingsIsMobile from './new_settings/use_settings_is_mobile';

export default function NewSettings() {
  const context = useContext(Context);
  const history = useHistory();
  const location = useLocation();
  const pagePadRef = useRef(null);
  const user = context.auth.getCurrentUser();
  const isMobile = useSettingsIsMobile(context);
  const selectedKey = activeKeyFromPath(location.pathname);
  const activeKey = selectedKey || 'account';
  const isMentor = user?.current_profile_type === 'PatientPartner';
  const phoneCallsEnabled = isMentor && isPhoneCallsEnabled(context.auth.currentAccount());
  const showMobileHub = isMobile && !selectedKey;

  useEffect(() => {
    pagePadRef.current?.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.includes('/appearance')) {
      history.replace('/member/settings');
    }
  }, [history, location.pathname]);

  const selectSection = (key) => {
    history.push(pathForSection(key, isMobile));
  };

  const goBackToHub = () => history.push('/member/settings');

  const renderSubpage = (showBack = false) => {
    switch (activeKey) {
      default:
        return (
          <AccountSubpage
            user={user}
            onManageProfile={() => history.push('/member/profile/edit')}
            showBack={showBack}
            onBack={goBackToHub}
          />
        );
    }
  };

  return (
    <SettingsShell>
      <div className={styles.page_pad} ref={pagePadRef}>
        <div className={styles.page_inner}>
          {showMobileHub ? (
            <MobileHub onSelect={selectSection} onSignOut={() => context.auth.userLogOut()} />
          ) : isMobile ? (
            <section className={styles.detail} key={activeKey}>
              {renderSubpage(true)}
            </section>
          ) : (
            <>
              <Rail activeKey={activeKey} onSelect={selectSection} onSignOut={() => context.auth.userLogOut()} />
              <section className={styles.detail} key={activeKey}>
                {renderSubpage(false)}
              </section>
            </>
          )}
        </div>
      </div>
      <BottomNav isPhoneCallsEnabled={phoneCallsEnabled} />
    </SettingsShell>
  );
}

export { NewProfileEdit };
